import { render } from "./WazzupIframeModal.vue?vue&type=template&id=50465469&scoped=true"
import script from "./WazzupIframeModal.vue?vue&type=script&lang=js"
export * from "./WazzupIframeModal.vue?vue&type=script&lang=js"

import "./WazzupIframeModal.vue?vue&type=style&index=0&id=50465469&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50465469"]])

export default __exports__